import EntityModel from '@/common/models/entity-model';
import taxCategories from '@/data/tax-categories';

export default class ProductModel extends EntityModel {
    hydrate({
        id = null,
        name = null,
        unitLabel = null,
        description = null,
        taxCategoryId = null,
        requiresShipping = false,
        accountingCode = null,
        options = [],
        createdTime = null,
        updatedTime = null,
        customFields = null,
    } = {}) {
        this.id = id;
        this.name = name;
        this.unitLabel = unitLabel;
        this.description = description;
        this.taxCategoryId = taxCategoryId;
        this.requiresShipping = requiresShipping;
        this.accountingCode = accountingCode;
        this.options = options;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
        this.customFields = customFields;
    }

    get taxInformation() {
        const tax = taxCategories.find(category => category.taxCode === this.taxCategoryId);
        if (tax) {
            return tax;
        }
        return null;
    }

    getPayload() {
        return {
            id: this.id,
            name: this.name,
            unitLabel: this.unitLabel,
            description: this.description,
            taxCategoryId: this.taxCategoryId,
            requiresShipping: this.requiresShipping,
            accountingCode: this.accountingCode,
            options: this.options,
            customFields: this.customFields,
        };
    }
}
